module.exports = __webpack_public_path__ + "static/media/checkmark_check_tick-green_bg.86c87fcd.svg";